import { takeEvery, call, put, select } from 'redux-saga/effects'

import { BOOK_TYPE, ebookKeys } from 'app/constants/ebook.constants'
import { isEmpty } from 'app/utils/array'

import {
  EBOOKS_ACTIONS,
  BIBLIOTECA_ACTIONS,
  CAMINOS_ACTIONS,
  TEXAS_ELAR_ACTIONS,
  TEXAS_SLAR_ACTIONS,
  ebooksActionCreators,
  bibliotecaActionCreators,
  caminosActionCreators,
  texasElarActionCreators,
  texasSlarActionCreators,
} from 'app/store/actions/media/ebooks.actions'
import { getEbooks } from 'app/services/api/data.service'
import { ReduxSagaAction } from 'app/types/store.types'

const actions = {
  [BOOK_TYPE.LIBRARY]: ebooksActionCreators,
  [BOOK_TYPE.LIBRARY3]: ebooksActionCreators,
  [BOOK_TYPE.BIBLIOTECA]: bibliotecaActionCreators,
  [BOOK_TYPE.CAMINOS_BIBLIOTECA]: caminosActionCreators,
  [BOOK_TYPE.TEXAS_ELAR]: texasElarActionCreators,
  [BOOK_TYPE.TEXAS_SLAR]: texasSlarActionCreators,
}

function* getEbooksSaga({
  payload: bookCategory,
}: ReduxSagaAction<keyof typeof ebookKeys>): Generator {
  let action
  try {
    const ebookKey = ebookKeys[bookCategory] || ebookKeys.LIBRARY
    action = actions[bookCategory] || actions.LIBRARY

    let data = yield select((state) => state.ebooks[ebookKey].data)

    if (isEmpty(data)) {
      const contentToken = yield select((state) => state.userData.contentToken)
      data = yield call(getEbooks, bookCategory, contentToken as string)
    }

    yield put(action.success({ data }))
  } catch (error) {
    if (action) {
      yield put(action.failure({ error }))
    }
  }
}

export default function* watchEbooksActions() {
  yield takeEvery(
    [
      EBOOKS_ACTIONS.REQUEST,
      BIBLIOTECA_ACTIONS.REQUEST,
      CAMINOS_ACTIONS.REQUEST,
      TEXAS_SLAR_ACTIONS.REQUEST,
      TEXAS_ELAR_ACTIONS.REQUEST,
    ],
    getEbooksSaga
  )
}
